// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1b0UW","author":"Table_author__1K7RO","authorImage":"Table_authorImage__221ox","unreadRow":"Table_unreadRow__1pc59"};